import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isActiveGroup: false,
    currentGroup: null,
}

const groupSlice = createSlice({
    name: 'group',
    initialState,
    reducers: {
        fetchingGroupSuccess: (state, action) => {
            state.isActiveGroup = true;
            state.currentGroup = action.payload;
        },
        fetchingGroupReset: (state) => {
            state.isActiveGroup = false;
            state.currentGroup = null;
        },
    }
});

export const { fetchingGroupSuccess, fetchingGroupReset } = groupSlice.actions;

export default groupSlice.reducer;